import request from '../request'

export default {
  getDispositivos() {
    return request.get('dispositivo')
  },

  getDispositivoById(idGeoDispositivo) {
    return request.get(`dispositivo/${idGeoDispositivo}`)
  },

  addDispositivo(data) {
    return request.post('dispositivo', data)
  },

  updateDispositivo(data){
    return request.put('dispositivo', data)
  },

  getTrackFechasDispositivo(data) {
    return request.post('dispositivo/track_fechas_dispositivo', data)
  },

  getConnectionStatus() {
    return request.get('dispositivo/getConnectionStatus')
  },

  getGeoResponsables() {
    return request.get('geo_responsable')
  },
}
